import { render, staticRenderFns } from "./AButton.vue?vue&type=template&id=27d9c821&scoped=true"
import script from "./AButton.vue?vue&type=script&lang=js"
export * from "./AButton.vue?vue&type=script&lang=js"
import style0 from "./AButton.vue?vue&type=style&index=0&id=27d9c821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d9c821",
  null
  
)

export default component.exports